module.exports = __webpack_public_path__ + "img/logo-bci.1e038018.svg";